module.exports={
	"Scope": "UserRoleJoin-List",
	"CoreEntity": "UserRoleJoin",
	"TitleTemplate": "User Role Assignments",
	"Descriptors":
	{
		"IDUser":
		{
			"Name": "User ID",
			"Hash": "URJListIDUser",
			"PictDashboard": {}
		},
		"IDRole":
		{
			"Name": "Role ID",
			"Hash": "URJListIDRole",
			"PictDashboard": {}
		},
		"ProxyIDRole":
		{
			"Name": "Proxy Role ID",
			"Hash": "URJListProxyIDRole",
			"PictDashboard": {}
		}
	}
}
